import { create } from 'zustand';

interface FeedFilterState {
  frameworks: string[];
  urgencyLevels: string[];
  toggleFramework: (fw: string) => void;
  toggleUrgency: (level: string) => void;
  clearFilters: () => void;
}

export const useFeedFilterStore = create<FeedFilterState>((set) => ({
  frameworks: [],
  urgencyLevels: [],

  toggleFramework: (fw) =>
    set((state) => ({
      frameworks: state.frameworks.includes(fw)
        ? state.frameworks.filter((f) => f !== fw)
        : [...state.frameworks, fw],
    })),

  toggleUrgency: (level) =>
    set((state) => ({
      urgencyLevels: state.urgencyLevels.includes(level)
        ? state.urgencyLevels.filter((l) => l !== level)
        : [...state.urgencyLevels, level],
    })),

  clearFilters: () => set({ frameworks: [], urgencyLevels: [] }),
}));
